const LoginDataTestIDs = {
  InternalLoginLink: 'link-internallogin',
  EmailInput: 'input-loginemail',
  PasswordInput: 'input-loginpassword',
  SubmitEmailPassword: 'input-loginsubmit',
} as const;

export { LoginDataTestIDs };
